import { createFileRoute } from "@tanstack/react-router";

import { AuthGate } from "@/components/AuthGate";
import { LoginFlowApprove } from "@/components/LoginFlowApprove";

// Authenticated route - AuthGate shows the login form in place if the
// user isn't logged in; once they log in, the approve view appears
// for the same token. No return-URL plumbing needed because the
// AuthGate hands control back to the same component once `user`
// flips.
export const Route = createFileRoute("/login-flow/$token")({
  component: function LoginFlowPage() {
    const { token } = Route.useParams();
    return (
      <AuthGate>
        <LoginFlowApprove token={token} />
      </AuthGate>
    );
  },
});
